/* eslint-disable camelcase */
import api from './axios'

export interface BlogPost {
  id: number
  title: string
  slug: string
  category: string
  excerpt: string
  author: string
  cover_image: string | null
  read_time: number
  published_at: string | null
  created_at: string
}

export interface BlogPostDetail extends BlogPost {
  content: string
  author_avatar: string | null
}

export interface BlogListResponse {
  data: BlogPost[]
  total: number
  page: number
  per_page: number
  total_pages: number
}

export interface BlogCreatePayload {
  title: string
  category: string
  excerpt: string
  content: string
  author: string
  read_time?: number
  published_at?: string | null
}

export const blogsApi = {
  // ── Public ───────────────────────────────────────────────────────────────
  list (params: { category?: string; page?: number; limit?: number } = {}) {
    return api.get<BlogListResponse>('/blogs', { params })
  },

  get (id: number) {
    return api.get<BlogPostDetail>(`/blogs/${id}`)
  },

  // ── Admin ────────────────────────────────────────────────────────────────
  adminList (params: { category?: string; page?: number; limit?: number } = {}) {
    return api.get<BlogListResponse>('/admin/blogs', { params })
  },

  adminCreate (payload: BlogCreatePayload) {
    return api.post<BlogPostDetail>('/admin/blogs', payload)
  },

  adminUpdate (id: number, payload: Partial<BlogCreatePayload>) {
    return api.put<BlogPostDetail>(`/admin/blogs/${id}`, payload)
  },

  adminUploadCover (id: number, file: File) {
    const formData = new FormData()
    formData.append('image', file)
    return api.post<{ cover_image: string }>(`/admin/blogs/${id}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  adminDelete (id: number) {
    return api.delete<{ message: string }>(`/admin/blogs/${id}`)
  }
}
